enum ENVIRONMENT {
  'local', 'dev', 'preprod', 'prod', 'localtest'
}

const LOCALTEST = false; // Set to true when testing backend locally 

const getEnv = () => {
  if(LOCALTEST) {
    console.log("TESTING LOCALLY");
    return ENVIRONMENT.localtest;
  } else {
    const hostname = window && window.location && window.location.hostname;
    switch (hostname) {
      case 'localhost':
        return ENVIRONMENT.local;
      case 'numerusapp.z16.web.core.windows.net':
        return ENVIRONMENT.dev;
      case 'numerusnova-test.serty.fi':
      case 'numetapp.z16.web.core.windows.net':
        return ENVIRONMENT.preprod;
      case 'numerusnova.serty.fi':
      case 'numerusnova.z16.web.core.windows.net':
        return ENVIRONMENT.prod;
      default:
        return ENVIRONMENT.local;
    }
  }
}

const LOGIN_URLS = {
  [ENVIRONMENT.local]: 'http://localhost:3000',
  [ENVIRONMENT.dev]: 'https://numerusapp.z16.web.core.windows.net/',
  [ENVIRONMENT.preprod]: 'https://numerusnova-test.serty.fi/',
  [ENVIRONMENT.prod]: 'https://numerusnova.serty.fi/',
  [ENVIRONMENT.localtest]: 'http://localhost:3000'
}

const BASE_URLS = {
  [ENVIRONMENT.local]: 'https://numdev-functions.azurewebsites.net',
  [ENVIRONMENT.dev]: 'https://numdev-functions.azurewebsites.net',
  [ENVIRONMENT.preprod]: 'https://numet-functions.azurewebsites.net',
  [ENVIRONMENT.prod]: 'https://numerus-functions.azurewebsites.net',
  [ENVIRONMENT.localtest]: 'http://localhost:7071'
}

const CLIENT_IDS = {
  [ENVIRONMENT.local]: 'da487e05-89b9-49ba-9a0f-b4b4e99112b5',
  [ENVIRONMENT.dev]: 'da487e05-89b9-49ba-9a0f-b4b4e99112b5',
  [ENVIRONMENT.preprod]: 'f13793e9-bdc6-4be3-ac43-c51240be94aa',
  [ENVIRONMENT.prod]: '4b3995e5-6137-453e-9867-298b32cdb9b1',
  [ENVIRONMENT.localtest]: 'da487e05-89b9-49ba-9a0f-b4b4e99112b5'
}

const TENANT_ID = '37727452-1ffe-4a89-a215-7ad76ed85eb4';

export const getLoginUrl = () => {
  return LOGIN_URLS[getEnv()];
}

export const getClientId = () => {
  return CLIENT_IDS[getEnv()];
}

export const getTenantId = () => {
  return TENANT_ID;
}

export const getFunctionBaseUrl = () => {
  return BASE_URLS[getEnv()];
}
